import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTimeType = (
    token: string,
    backend: string,
    id: string
) => {
    return fetch(
        `${getApiUrl(backend)}timeTypes/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default  getTimeType;
